/*
  Clipz-it - Cards produits dynamiques dans les articles de blog.
  Met a jour le prix et le statut de stock depuis /products/{handle}.js
  Si l'appel echoue, le prix ecrit en dur dans le HTML reste affiche.
  Aucune donnee promotionnelle n'est injectee : ni prix barre, ni badge, ni note.
*/
(function () {
  'use strict';

  var CARDS_SELECTOR = '.cz-article-product-card[data-product-handle]';

  var formatPrice = function (cents) {
    try {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' EUR';
    }
  };

  function updateCard(card) {
    var handle = card.getAttribute('data-product-handle');
    if (!handle) return;

    fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (product) {
        if (!product) return;

        var priceEl = card.querySelector('[data-price]');
        if (priceEl && typeof product.price === 'number') {
          priceEl.textContent = formatPrice(product.price);
        }

        var stockEl = card.querySelector('[data-stock-status]');
        if (stockEl) {
          if (product.available === false) {
            stockEl.textContent = 'Rupture temporaire';
            stockEl.classList.add('cz-stock-empty');
            stockEl.classList.remove('cz-stock-available');
          } else {
            stockEl.textContent = 'En stock';
            stockEl.classList.add('cz-stock-available');
            stockEl.classList.remove('cz-stock-empty');
          }
        }

        if (card.hasAttribute('data-sync-image')) {
          var imgEl = card.querySelector('img');
          if (imgEl && product.featured_image) {
            imgEl.src = product.featured_image;
          }
        }
      })
      .catch(function () {
        /* Silencieux : le prix et le stock ecrits en dur restent visibles. */
      });
  }

  function init() {
    var cards = document.querySelectorAll(CARDS_SELECTOR);
    if (!cards.length) return;
    Array.prototype.forEach.call(cards, updateCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
